export default {
	data: () => ({
		pickerDateVisible: false,
		pickerTimeVisible: false
	}),
	computed: {
		patientId() {
			return this.$store.getters['account/getPatientId']
		},
		patientInfo() {
			return this.$store.getters['account/patientInfo']
		}
	},
	async created() {
		await this.load()
	},
	methods: {
		// 确认选择日期
		clickDatePickerConfirm(value) {
			this.$set(this.params, 'measureDate', this.$moment(value).format('YYYY-MM-DD'))
			this.pickerDateVisible = false
		},
		// 确认选择时间
		clickTimePickerConfirm(value) {
			this.$set(this.params, 'measureTime', value)
			this.pickerTimeVisible = false
		},

		// 加载详情
		async load() {
			if (this.$route.params.id) {
				const res = await this.getApi('detailApi')(this.$route.params.id)
				if (!res.code) {
					Object.keys(this.params).forEach(key => {
						if (key === 'measureTime') {
							const dateTimeArr = res.data[key].split(' ')
							this.$set(this.params, 'measureDate', dateTimeArr[0])
							this.$set(
								this.params,
								'measureTime',
								dateTimeArr[1].substring(0, dateTimeArr[1].lastIndexOf(':'))
							)
						} else {
							this.$set(this.params, key, res.data[key] + '')
						}
					})
				}
			} else {
				this.$set(this.params, 'patientName', this.patientInfo.name)
				Object.keys(this.$route.query || {}).forEach(key => {
					this.$set(this.params, key, this.$route.query[key])
				})
				console.log(this.params)
			}
		},
		// 点击保存
		async clickSubmit() {
			if (!this.submitVerify()) return
			const params = JSON.parse(JSON.stringify(this.params))

			params.measureTime = `${params.measureDate} ${params.measureTime}:00`
			delete params.measureDate
			params.patientId = this.patientId

			let api = this.getApi('saveApi')
			if (this.$route.params.id) {
				api = this.getApi('updateApi')
				params.id = this.$route.params.id
			}
			const res = await api(params)
			if (!res.code) {
				this.$toast('保存成功')
				this.$router.go(-1)
			}
		},

		// 点击删除
		clickDelete() {
			this.$dialog
				.confirm({
					title: '',
					message: '确定要删除吗，删除后无法恢复',
					confirmButtonText: '删除'
				})
				.then(async () => {
					const res = await this.getApi('deleteApi')([this.$route.params.id])
					if (!res.code) {
						this.$toast('已删除')
						this.$router.go(-1)
					}
				})
				.catch(() => {})
		}
	}
}
